import en from 'antd/es/date-picker/locale/en_GB';
import lt from 'antd/es/date-picker/locale/lt_LT';

import { Object } from 'models';

export const CODE_LENGTH = 6;
export const PAGE_SIZE = 20;

export const DATE_FORMATTER = 'YYYY-MM-DD';

export const SUPPORTED_LANGUAGES = ['en', 'lt'];

export const WP_HOST =
	window.location.hostname === 'crowdpear.com'
		? 'https://crowdpear.com'
		: window.location.hostname.includes('crowdpear-react') ||
		  window.location.hostname.includes('localhost')
		? 'https://master.crowdpear-wp.p2p.aventus.work'
		: window.location.origin;

export const CHART_DATE_FORMATS: Object = {
	month: 'MMM D',
	'half-year': 'MMM',
	year: 'MMM',
	'all-time': 'Y',
};

export const LOCALES = { en, lt };

export const SECOND = 1000;
